module.exports = __webpack_public_path__ + "static/img/step2.a175cbcb.png";